import React from 'react';
import { formatVozrast, formatVysota, formatDiametr } from './utils';
import { toDecimalPoint } from '../../../utils/decimalUtils';
import DecimalInput from '../../fields/DecimalInput';

const PorodaCharacteristicsSection = ({
  isFieldsLocked,
  getCombinedPorodaCharacteristics,
  handbooks,
  updatePorodaCharacteristic
}) => {
  return (
    <div className="group-section">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
        <h4>Характеристика породы</h4>
      </div>
      <div>
        <table className="table">
          <thead>
            <tr>
              <th style={{ minWidth: '80px', width: '80px' }}>Ярус</th>
              <th style={{ minWidth: '80px', width: '80px' }}>Доля</th>
              <th style={{ minWidth: '150px', width: '150px' }}>Порода</th>
              <th style={{ minWidth: '120px', width: '120px' }}>Ср. возраст, лет</th>
              <th style={{ minWidth: '120px', width: '120px' }}>Ср. высота, м</th>
              <th style={{ minWidth: '120px', width: '120px' }}>Ср. диаметр, см</th>
            </tr>
          </thead>
          <tbody>
            {getCombinedPorodaCharacteristics().map((char) => (
              <tr key={char.id}>
                {/* Ярус */}
                <td className="coordinate-cell" style={{ minWidth: '80px', width: '80px' }}>
                  <input
                    type="text"
                    value={char.yarus}
                    readOnly
                    className="form-control coordinate-field"
                    style={{ background: '#f8f9fa', cursor: 'not-allowed' }}
                  />
                </td>

                {/* Доля */}
                <td className="coordinate-cell" style={{ minWidth: '80px', width: '80px' }}>
                  <input
                    type="text"
                    value={char.dolap}
                    readOnly
                    className="form-control coordinate-field"
                    style={{ background: '#f8f9fa', cursor: 'not-allowed' }}
                  />
                </td>

                {/* Порода */}
                <td className="coordinate-cell" style={{ minWidth: '150px', width: '150px' }}>
                  <input
                    type="text"
                    value={(() => {
                      const handbook = handbooks?.find(h => h.id === 31);
                      if (handbook && handbook.references && char.kodporodato) {
                        const selectedOption = handbook.references.find(r => r.id.toString() === char.kodporodato);
                        return selectedOption ? selectedOption.name : char.kodporodato;
                      }
                      return char.kodporodato || '';
                    })()}
                    readOnly
                    className="form-control coordinate-field"
                    style={{ background: '#f8f9fa', cursor: 'not-allowed' }}
                  />
                </td>

                {/* Ср. возраст, лет */}
                <td className="coordinate-cell" style={{ minWidth: '120px', width: '120px' }}>
                  <input
                    type="number"
                    min="0"
                    max="999"
                    value={char.vozr}
                    onChange={(e) => {
                      if (!isFieldsLocked) {
                        updatePorodaCharacteristic(char.id, 'vozr', e.target.value);
                      }
                    }}
                    onBlur={(e) => {
                      if (!isFieldsLocked) {
                        const formatted = formatVozrast(e.target.value);
                        updatePorodaCharacteristic(char.id, 'vozr', formatted);
                      }
                    }}
                    readOnly={isFieldsLocked}
                    className={`form-control coordinate-field ${isFieldsLocked ? 'locked-field' : ''}`}
                    style={isFieldsLocked ? { background: '#f8f9fa', cursor: 'not-allowed' } : {}}
                    placeholder="0-999"
                  />
                </td>

                {/* Ср. высота, м */}
                <td className="coordinate-cell" style={{ minWidth: '120px', width: '120px' }}>
                  <DecimalInput
                    value={char.hsr}
                    onChange={(e) => {
                      if (!isFieldsLocked) {
                        updatePorodaCharacteristic(char.id, 'hsr', toDecimalPoint(e.target.value));
                      }
                    }}
                    onBlur={(e) => {
                      if (!isFieldsLocked) {
                        const formatted = formatVysota(e.target.value);
                        updatePorodaCharacteristic(char.id, 'hsr', formatted);
                      }
                    }}
                    readOnly={isFieldsLocked}
                    className={`form-control coordinate-field ${isFieldsLocked ? 'locked-field' : ''}`}
                    style={isFieldsLocked ? { background: '#f8f9fa', cursor: 'not-allowed' } : {}}
                    placeholder="0.0-999.9"
                  />
                </td>

                {/* Ср. диаметр, см */}
                <td className="coordinate-cell" style={{ minWidth: '120px', width: '120px' }}>
                  <DecimalInput
                    value={char.dsr}
                    onChange={(e) => {
                      if (!isFieldsLocked) {
                        updatePorodaCharacteristic(char.id, 'dsr', toDecimalPoint(e.target.value));
                      }
                    }}
                    onBlur={(e) => {
                      if (!isFieldsLocked) {
                        const formatted = formatDiametr(e.target.value);
                        updatePorodaCharacteristic(char.id, 'dsr', formatted);
                      }
                    }}
                    readOnly={isFieldsLocked}
                    className={`form-control coordinate-field ${isFieldsLocked ? 'locked-field' : ''}`}
                    style={isFieldsLocked ? { background: '#f8f9fa', cursor: 'not-allowed' } : {}}
                    placeholder="0.0-9999.9"
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PorodaCharacteristicsSection;

